import React, { useEffect, useRef, useState } from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import { TListingClient } from 'types/TListing';

type TAdmarktSimilarItemsAppProps = {
  appState: {
    listing: {
      itemId: TListingClient['itemId'];
      flags: TListingClient['flags'];
    };
  };
  environment: any;
};

let AdmarktSimilarItems;

const AdmarktSimilarItemsApp = ({ appState, environment }: TAdmarktSimilarItemsAppProps) => {
  const {
    listing: {
      itemId,
      flags: { requestRelevantItems, isAdmarkt },
    },
  } = appState;
  const admarktSimilarItemsRef = useRef<HTMLDivElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (isAdmarkt || !requestRelevantItems) {
      return;
    }

    const elementRef = admarktSimilarItemsRef.current as Element;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            (async () => {
              try {
                AdmarktSimilarItems = (
                  await import(
                    /* webpackChunkName: "admarktSimilarItems" */ './components/AdmarktSimilarItems/AdmarktSimilarItems'
                  )
                ).default;
                setIsLoaded(true);
              } catch {}
            })();
          }
        });
      },
      {
        rootMargin: '0px 0px 400px 0px',
      },
    );

    if (elementRef) {
      observer.observe(elementRef);
    }

    return () => {
      if (elementRef) {
        observer.disconnect();
      }
    };
  }, [isAdmarkt, requestRelevantItems]);

  if (isAdmarkt || !requestRelevantItems) {
    return null;
  }

  return (
    <EnvironmentProvider value={environment}>
      <div className="AdmarktSimilarItemsContainer hz-Page-section" ref={admarktSimilarItemsRef}>
        {isLoaded && <AdmarktSimilarItems itemId={itemId} />}
      </div>
    </EnvironmentProvider>
  );
};

export default AdmarktSimilarItemsApp;
